import { render } from "./LayoutMain.vue?vue&type=template&id=2952c232&scoped=true"
import script from "./LayoutMain.vue?vue&type=script&lang=js"
export * from "./LayoutMain.vue?vue&type=script&lang=js"

import "./LayoutMain.vue?vue&type=style&index=0&id=2952c232&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2952c232"]])

export default __exports__